module.exports = require("./build/ng-csv.min.js");


//////////////////
// WEBPACK FOOTER
// ng-csv (bower component)
// module id = 435
// module chunks = 0